export const FULLSCREEN_DIALOG = {
  maxHeight: '100vh',
  maxWidth: '100vw',
  height: '100%',
  width: '100%'
};
